
import { ImageSizeTypeEnum } from "./ImageSizeTypeEnum"
export function describeImageSizeTypeEnum(e: ImageSizeTypeEnum): string{
    switch(e){
        case ImageSizeTypeEnum.Large:
            return "@!large";
        case ImageSizeTypeEnum.Thumbnail44whFill:
            return "@!44wh-fill";
        case ImageSizeTypeEnum.Thumbnail100whFill:
            return "@!100wh-fill";
        case ImageSizeTypeEnum.Thumbnail200whFill:
            return "@!200wh-fill";
        case ImageSizeTypeEnum.Thumbnail300whFill:
            return "@!300wh-fill";
        case ImageSizeTypeEnum.Thumbnail400_300whFill:
            return "@!400-300wh-fill";
        case ImageSizeTypeEnum.Thumbnail100wh7rFill:
            return "@!100wh7r-fill";
        case ImageSizeTypeEnum.Thumbnail80wh40crFill:
            return "@!80wh40cr-fill";
        case ImageSizeTypeEnum.Thumbnail200w:
            return "@!200w";
        case ImageSizeTypeEnum.Thumbnail200whFit:
            return "@!200wh-fit";
        case ImageSizeTypeEnum.Thumbnail750_440whFill:
            return "@!750-440wh-fill";
        case ImageSizeTypeEnum.Thumbnail1920_500whFill:
            return "@!1920-500wh-fill";
        case ImageSizeTypeEnum.Thumbnail1600_500whFill:
            return "@!1600-500wh-fill";
        case ImageSizeTypeEnum.Thumbnail1440_500whFill:
            return "@!1440-500wh-fill";
        case ImageSizeTypeEnum.Thumbnail1280_500whFill:
            return "@!1280-500wh-fill";
        case ImageSizeTypeEnum.Thumbnail440whFill:
            return "@!440wh-fill";
        case ImageSizeTypeEnum.Thumbnail500hAlpha:
            return "@!500ha";
        case ImageSizeTypeEnum.Thumbnail120_60whLongSideAlpha:
            return "@!120-60whla";
        case ImageSizeTypeEnum.Thumbnail100whLongSideAlpha:
            return "@!100whla";
        case ImageSizeTypeEnum.Thumbnail80whAlphaFit:
            return "@!80wha-fit";
        case ImageSizeTypeEnum.Thumbnail200whAlphaFill:
            return "@!200wha-fill";
        case ImageSizeTypeEnum.AssetsOrigin:
            return "@!origin";
        case ImageSizeTypeEnum.AssetsGif:
            return "@!gif";
        case ImageSizeTypeEnum.Thumbnail44whaFill:
            return "@!44wha-fill";
        case ImageSizeTypeEnum.Thumbnail1920_728whFill:
            return "@!1920-728wh-fill";
        case ImageSizeTypeEnum.Thumbnail1600_728whFill:
            return "@!1600-728wh-fill";
        case ImageSizeTypeEnum.Thumbnail1440_728whFill:
            return "@!1440-728wh-fill";
        case ImageSizeTypeEnum.Thumbnail1280_728whFill:
            return "@!1280-728wh-fill";
        case ImageSizeTypeEnum.Thumbnail1920_600whFill:
            return "@!1920-600wh-fill";
        case ImageSizeTypeEnum.Thumbnail1600_600whFill:
            return "@!1600-600wh-fill";
        case ImageSizeTypeEnum.Thumbnail1440_600whFill:
            return "@!1440-600wh-fill";
        case ImageSizeTypeEnum.Thumbnail1280_600whFill:
            return "@!1280-600wh-fill";
        default:
            throw new Error(`${e} is an invalid ImageSizeTypeEnum`);
    }
}
		